import List from 'containers/Users/List';
import Create from 'containers/Users/Create';
import Edit from 'containers/Users/Edit';

export default { List, Create, Edit };
